/* @flow */

import * as React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import formStyles from '../styles/FormGeneral.scss';

type ComponentProps = {|
    intl: intlShape,
    errorMessage: string,
    onChange: (e: SyntheticEvent<HTMLSelectElement>) => void,
    value: string,
|};

//TODO: Dynamically change the currency value based on visitor's location
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

const placeholder = defineMessages({
    placeholder: {
        id: 'abt.matchmaker.form.matchmaker_placeholder',
        defaultMessage: 'Select your budget',
    },
});

const messages = defineMessages({
    budget1: {
        id: 'abt.matchmaker.form.matchmaker_option_budget1',
        defaultMessage: 'Under {max}',
    },
    budget2: {
        id: 'abt.matchmaker.form.matchmaker_option_budget2',
        defaultMessage: '{min} - {max}',
    },
    budget3: {
        id: 'abt.matchmaker.form.matchmaker_option_budget3',
        defaultMessage: '{min} - {max}',
    },
    budget4: {
        id: 'abt.matchmaker.form.matchmaker_option_budget4',
        defaultMessage: '{min} - {max} million',
    },
    budget5: {
        id: 'abt.matchmaker.form.matchmaker_option_budget5',
        defaultMessage: '{min} million+',
    },
});

const BudgetComponent = ({ intl, errorMessage, onChange, value }: ComponentProps) => {
    const budgetOptions = [
        intl.formatMessage(messages.budget1, {
            max: formatter.format(10000),
        }),
        intl.formatMessage(messages.budget2, {
            min: formatter.format(10000),
            max: formatter.format(25000),
        }),
        intl.formatMessage(messages.budget2, {
            min: formatter.format(25000),
            max: formatter.format(50000),
        }),
        intl.formatMessage(messages.budget2, {
            min: formatter.format(50000),
            max: formatter.format(100000),
        }),
        intl.formatMessage(messages.budget2, {
            min: formatter.format(100000),
            max: formatter.format(250000),
        }),
        intl.formatMessage(messages.budget3, {
            min: formatter.format(250000),
            max: formatter.format(500000),
        }),
        intl.formatMessage(messages.budget4, {
            min: formatter.format(500000),
            max: formatter.format(1),
        }),
        intl.formatMessage(messages.budget5, {
            min: formatter.format(1),
        }),
    ];

    return (
        <div className={formStyles.formWrapper}>
            <BasicSelect
                dataTn="matchmaker-input-budget"
                errorMessage={errorMessage}
                placeholder={intl.formatMessage(placeholder.placeholder)}
                options={budgetOptions.map(option => ({ value: option, label: option }))}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};

export const Budget = injectIntl(BudgetComponent);
